import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_NEWS } from '@/modules/news/router';
import { newsService } from '@/services/news';
import { useVuelidate } from '@vuelidate/core';
import { useMixins } from './mixins';

export function useNewsContent() {
    const router = useAppRouter();

    const { model, updateContentValidation, fetch } = useMixins();
    const v$ = useVuelidate(updateContentValidation, model);

    const actions = {
        updateContent: useCrudActions().excuteAndNotify({
            validator: v$,
            request: () => {
                const fromRegisterTime = model.fromRegisterTime?.getTime() ?? null;
                const toRegisterTime = model.toRegisterTime?.getTime() ?? null;

                let target = null;
                if (model.targetType == 0) {
                    target = 'link:' + model.target;
                } else if (model.targetType == 1) {
                    target = 'popup:' + model.target;
                } else if (model.targetType == 2) {
                    target = 'deeplink:' + model.target;
                }

                return newsService.updateContent(
                    model.id,
                    model.name,
                    target,
                    fromRegisterTime,
                    toRegisterTime,
                    model.imageFile,
                    model.thumbnailFile
                );
            },
            onSuccess: () => router.push({ name: ROUTE_NAME_NEWS.INDEX })
        })
    };

    return { model, v$, fetch, actions };
}
